import ajax from './http'

const userServer = {
  // 用户使用TG授权登陆
  loginInfo(param) {
    return ajax({
      url: '/user/login',
      type: 'post',
      params: param
    })
  },
  // 用户使用TG授权登陆
  getUserInfo(param) {
    return ajax({
      url: '/user/getUserInfo',
      type: 'get',
      params: param
    })
  },
  // 修改个人资料
  editUserInfo(param) {
    return ajax({
      url: '/user/editUser',
      type: 'post',
      params: param
    })
  },
  // 退出登陆
  loginOut(param) {
    return ajax({
      url: '/user/logout',
      type: 'post',
      params: param
    })
  }

}

export default userServer
